<div class="wrapper flex flex-col overflow-y-auto max-h-[528px]">
  <app-toggle-buttons
    [buttonLabels]="responseOptions"
    [parentFormGroup]="questionFrom"
    class="field-value-section mb-[40px]"
    controlName="field_values"
    />
  <app-check-box
    [parentFormGroup]="questionFrom"
    class="field-value-section mb-[40px]"
    controlName="applyToAll"
    label="Apply answer to all questions"
    />
  @if (displayCommentSection || questionFrom.controls['comment']?.value) {
    <div
      class="comment-section mb-[20px]"
      >
      <app-text-area
        [parentFormGroup]="questionFrom"
        controlName="comment"
        label="COMMENT"
        />
    </div>
  }
  @if (selectedMediaFiles?.length) {
    <app-pictures-section
      (onDelete)="deletePicture($event)"
      [pictures]="selectedMediaFiles"
      class="pictures-section mb-[40px]"
      />
  }
</div>
